import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MescommandesPage } from './mescommandes.page';

const routes: Routes = [
  {
    path: '',
    component: MescommandesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MescommandesPageRoutingModule {}
